var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"6px"},style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[(_vm.errorMail)?_c('img',{attrs:{"src":require("@/assets/images/other-icons/error.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }